var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 overflow-hidden h-100 background d-flex justify-content-center align-items-center",style:(_vm.backgroundStyle),attrs:{"id":"WordCloud"}},[_c('vue-word-cloud',{staticClass:"w-100 h-100",attrs:{"spacing":0.5,"words":_vm.wordsArray,"font-family":_vm.currentFontFamily}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }